/* eslint-disable @typescript-eslint/camelcase */
import it from './it_IT';
import es from './es_ES';
import en from './en_EN';

export default { es, it, en };
